// Notification types

export enum NotificationType {
  WorkflowTransition = 'WorkflowTransition',
  TeamAssignment = 'TeamAssignment',
  SlaWarning = 'SlaWarning',
  SlaBreached = 'SlaBreached',
  BatchCreated = 'BatchCreated',
  BatchCompleted = 'BatchCompleted',
  ReviewRequired = 'ReviewRequired',
  ApprovalRequired = 'ApprovalRequired',
  NormRequired = 'NormRequired',
  NormUpgradeAvailable = 'NormUpgradeAvailable',
}

export enum NotificationChannel {
  InApp = 'InApp',
  Email = 'Email',
  Both = 'Both',
}

export interface Notification {
  id: number;
  type: NotificationType | string;
  title: string;
  message: string;
  entityType?: string;
  entityId?: number;
  isRead: boolean;
  readAt?: string;
  channel: NotificationChannel | string;
  createdAt: string;
  tier: number;
  groupedCount: number;
  isGrouped: boolean;
  updatedAt?: string;
}

export interface NotificationListResponse {
  items: Notification[];
  totalCount: number;
  unreadCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface NotificationListRequest {
  pageNumber?: number;
  pageSize?: number;
  isRead?: boolean;
  type?: string;
}

export interface NotificationCount {
  unreadCount: number;
  totalCount: number;
}

export interface GroupedNotificationResponse {
  needsYourAction: Notification[];
  slaAlerts: Notification[];
  updates: Notification[];
  actionCount: number;
  slaCount: number;
  updateCount: number;
}

export interface UserNotificationPreference {
  emailDigestEnabled: boolean;
  digestTime: string;
  digestTimeZone: string;
  emailMuted: boolean;
  typeOverrides?: Record<string, string>;
}

export interface UpdateNotificationPreferenceRequest {
  emailDigestEnabled?: boolean;
  digestTime?: string;
  digestTimeZone?: string;
  emailMuted?: boolean;
  typeOverrides?: Record<string, string>;
}
